<!--
Author: TangChen
Date: 2018-09-10
Desc: 设置未开户下页面顶部导航，为公共组件
 -->
<template>
    <div class="comp-nav-bar comp">
        <div class="nav-bar">
            <div v-for="(nav,index) in navs" :key="nav.val" class="nav-list" :style="{width:parseFloat(100/navs.length).toString().substr(0,4)+'%'}" :class="{'is-active':nav.active}">
                <span v-if="!nav.icon" class="nav-list-id">{{ index+1 }}</span>
                <span v-else class="nav-list-id"> <i :class="nav.icon" /></span>
                <span class="nac-list-text">{{ nav.val }}</span>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: "NavBar",
    props: {
        navs: {
            type: Array,
            required: true
        }
    },
    data () {
        return {};
    },
    methods: {
    }
};
</script>
<style lang="scss">
.comp-nav-bar {
    .nav-bar {
        text-align: center;
        .nav-list {
            display: inline-block;
            vertical-align: middle;
            padding: 8px 0;
            line-height: 26px;
            font-size: 18px;
            &.is-active {
                position: relative;
            }
            &.is-active:before {
                content: '';
                width: 100%;
                height: 2px;
                position: absolute;
                bottom: -2px;
                left: 0;
            }
            .nav-list-id {
                display: inline-block;
                width: 26px;
                height: 26px;
                border-radius: 100% 100%;
                -webkit-border-radius: 100% 100%;
                margin-right: 15px;
                font-size: 20px;
            }
        }
    }
}
</style>
